/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Row, Col } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components";
import { useBillingPeriod } from "~/services/customers";
import { ReservationsCommitmentsAccessHandler } from "~/views/reservedInstances/components";
import { ReservationBanner } from "../components/ReservationBanner";
import {
  breadcrumbLabelsAWSRI,
  RESERVATION_BANNER_DEFAULT_PROPS,
} from "../constants";
import { AwsCurrentBillingPeriodPage } from "./AwsCurrentBillingPeriodPage";

export function AwsReservationsCommitmentsPage() {
  const { activateCurrentBillingPeriod, isCurrentBillingPeriod } =
    useBillingPeriod();

  return (
    <ReservationsCommitmentsAccessHandler accessTo="aws">
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Reservations And Commitments - AWS"
            labels={breadcrumbLabelsAWSRI}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <If condition={isCurrentBillingPeriod}>
            <Then>
              <AwsCurrentBillingPeriodPage />
            </Then>
            <Else>
              <ReservationBanner
                onClick={activateCurrentBillingPeriod}
                {...RESERVATION_BANNER_DEFAULT_PROPS}
              />
            </Else>
          </If>
        </Col>
      </Row>
    </ReservationsCommitmentsAccessHandler>
  );
}
